<template>
    <el-dialog v-dialog-drag :visible.sync="showDialog" width="1100px" :destroy-on-close="true" :before-close="cancel"
        title="发起合同签署" append-to-body>
        <div>
            <div style="display:flex;flex-direction: row-reverse;margin-bottom: 10px;">
                <el-button size="small" type="success" :disabled="loading" @click="handleApprove">提交</el-button>
            </div>
            <el-form :model="approve" label-width="110px" ref="approve" :rules="approveRules">
                <el-form-item label="签署方式" prop="onlineSignFlag">
                    <el-radio-group v-model="approve.onlineSignFlag">
                        <el-radio :label="true">线上</el-radio>
                        <el-radio :label="false">线下</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="签署标题" prop="signTitle">
                    <el-input type="text" :disabled="loading" v-model="approve.signTitle" placeholder="请输入签署标题">
                    </el-input>
                </el-form-item>
                <el-form-item label="客户名称" prop="contactName">
                    <el-input type="text" :disabled="loading" v-model="approve.contactName" placeholder="请输入客户名称">
                    </el-input>
                </el-form-item>

                <el-form-item label="客户电话" prop="contactPhone">
                    <el-input type="text" :disabled="loading" v-model="approve.contactPhone" placeholder="请输入客户电话">
                    </el-input>
                </el-form-item>
                <el-form-item label="签署文件" prop="file" v-if="approve.onlineSignFlag === false || contract.length > 1"
                    style="width: 100%!important;">
                    <el-upload action="" class="upload-demo" :auto-upload="false" :show-file-list="false"
                        :on-change="handleChange" :file-list="fileList" style="width: 100%;">
                        <div style="display: flex; width: 100%;">
                            <el-input v-model="fileName" readonly style="flex: 1;"></el-input>
                            <el-button size="small" style="margin-left: 10px;" type="primary">选择文件</el-button>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
        <el-tabs>
            <el-tab-pane label="合同信息"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeIndex" v-if="contract.length > 1">
            <el-tab-pane v-for="(item, index) in contract" :key="index" :label="'合同' + (index + 1)"
                :name="String(index)"></el-tab-pane>
        </el-tabs>
        <el-descriptions :column="2" :label-style="{ 'width': '20%' }" :content-style="{ 'width': '30%' }" border>
            <el-descriptions-item label="合同编号">{{
                contract[Number(activeIndex)].contractNumber
                }}
            </el-descriptions-item>
            <el-descriptions-item label="合同名称">{{
                contract[Number(activeIndex)].contractName
                }}
            </el-descriptions-item>
            <el-descriptions-item label="销售">{{ contract[Number(activeIndex)]?.sales?.name
                }}</el-descriptions-item>
            <el-descriptions-item label="有效期限">
                <el-tag>{{ contract[Number(activeIndex)].expirationDate + '年' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="合同拟定时间">{{
                contract[Number(activeIndex)].contractDraftingDate
                }}
            </el-descriptions-item>
            <el-descriptions-item label="合同金额">{{
                contract[Number(activeIndex)].contractAmount
                }}
            </el-descriptions-item>
            <el-descriptions-item label="增值金额"
                v-if="['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(contract[Number(activeIndex)].contractType)">
                {{ contract[Number(activeIndex)].addedAmount + '(' +
                    getProportion(contract[Number(activeIndex)].contractAmount, contract[Number(activeIndex)].addedAmount) + ')' }}
            </el-descriptions-item>
            <el-descriptions-item label="客户联系人">
                <span v-if="contract[Number(activeIndex)]?.customerContacts?.contactName">{{
                    contract[Number(activeIndex)].customerContacts.contactName }}</span>
                <span v-else style="color: #dd6161">系统内未找到</span>
            </el-descriptions-item>
            <el-descriptions-item label="受托方">{{
                contract[Number(activeIndex)]?.baseCompany?.companyName
                }}
            </el-descriptions-item>
            <el-descriptions-item label="受托方联系人">{{
                contract[Number(activeIndex)]?.trusteeContacts?.name
                }}
            </el-descriptions-item>
            <el-descriptions-item label="合同分类">
                <el-tag :type="getContractColor(contract[Number(activeIndex)].contractType, 'tagType')" :style="{
                    color: getContractColor(contract[Number(activeIndex)].contractType, 'color'),
                    'background-color': getContractColor(contract[Number(activeIndex)].contractType, 'backgroundColor'),
                    'border-color': getContractColor(contract[Number(activeIndex)].contractType, 'borderColor')
                }">
                    {{ getContractColor(contract[Number(activeIndex)].contractType, 'name') }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="合同类型">
                {{ contract[Number(activeIndex)].projectType }}
            </el-descriptions-item>
            <el-descriptions-item label="样品处理方式"
                v-if="['返样/暂存样品', '预付款扣款（返样/暂存样品）'].includes(contract[Number(activeIndex)].projectType)">
                {{ contract[Number(activeIndex)].sampleManagement === 'RETURN_SAMPLE' ? '返样' : '暂存样品' }}
            </el-descriptions-item>
            <el-descriptions-item label="核酸抽提">
                <el-tag type="success" v-if="contract[Number(activeIndex)].generateContractInfo?.extractionFlag">{{ '是'
                    }}</el-tag>
                <el-tag type="danger" v-else>{{ '否' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="创建时间">{{
                contract[Number(activeIndex)].createTime
                }}
            </el-descriptions-item>
            <el-descriptions-item label="签订地点">{{
                contract[Number(activeIndex)].signingPlace
                }}
            </el-descriptions-item>
            <el-descriptions-item label="合同" v-if="contract[Number(activeIndex)].contractFilePath">
                <el-button size="mini" type="primary" icon="el-icon-download" plain
                    @click="download(contract[Number(activeIndex)].id)">下载
                </el-button>
                <el-button size="mini" type="primary" icon="el-icon-view" plain
                    @click="preview(contract[Number(activeIndex)].id)">预览
                </el-button>
            </el-descriptions-item>
            <el-descriptions-item label="备注">{{ contract[Number(activeIndex)].remark
                }}</el-descriptions-item>
        </el-descriptions>
        <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
        <div v-show="loading" v-loading="loading" element-loading-text="提交中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.5)"
            style="position: fixed;top:50%;left:50%;transform: translate(-50%, -50%); background-color: rgba(0, 0, 0, .1); width: 300px;height: 250px;z-index: 10000; ">
        </div>
    </el-dialog>
</template>

<script>

import { attachmentContract } from "@/api/dilivery/sales/contract";
import FilePreview from "@/components/file/FilePreview.vue";
import ProjectInfoDialog from "@/components/sales/ProjectInfoDialog.vue";
import { getContractColor } from "@/color";
import { contractSignApply } from "@/api/dilivery/sign";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { getProportion } from "@/utils/float_decimal";
const baseURL = process.env.VUE_APP_BASE_API

export default {
    name: "AddSignContract",
    components: { ProjectInfoDialog, FilePreview },
    props: {
        showDialog: {
            default: false
        },
        contractDetail: {
            default: () => ([])
        }
    },
    data() {
        return {
            fileName:'',
            fileList:[],
            loading: false,
            showFile: false,
            fileInfo: '',
            contract:[],
            activeIndex:'0',
            approve: {
                signTitle:'',
                file:null,
                onlineSignFlag:true,
                contractIds: [],
                contactName: '',
                contactPhone:'',
            },
            approveRules: {
                signTitle: [{ required: true, message: '请输入签署标题', trigger: 'change' }],
                onlineSignFlag: [{ required: true, message: '请选择签署方式', trigger: 'change' }],
                contactName: [{ required: true, message: '客户名称不能为空', trigger: 'change' }],
                contactPhone: [{ required: true, message: '客户电话不能为空', trigger: 'change' }],
                file: [{ required: true, message: '请上传签署文件', trigger: 'change' }],
            }

        };
    },
    watch: {
        contractDetail: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.contract = newVal.map(item => item)
                    this.approve.contractIds = newVal.map(item => item.id)
                    this.approve.signTitle = newVal[0].contractName
                    this.approve.contactName = newVal[0].customerContacts.contactName
                    this.approve.contactPhone = newVal[0].customerContacts.phone
                }
            },
            immediate: true
        },
    },
    mounted() {
    },
    methods: {
        getProportion,
        handleChange (file,fileList) {
            this.fileList = [file]
            this.approve.file = file
            this.fileName = file.name
        },
        getContractColor,
        async download(id) {
            try {
                let url = `${baseURL}/sequencing-contract/attachment/${id}/CONTRACT_ANNEX?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink);
            } catch (error) {
                console.log(error);
            }
        },
        async preview(id, type) {
            try {
                this.fileInfo = await attachmentContract(id, 'CONTRACT_ANNEX')
                this.showFile = true
            } catch (error) {
                console.log(error);
            }
        },
        cancel() {
            this.$emit('submit', 'cancel')
        },
        handleApprove() {
            this.loading = true
            this.$refs.approve.validate(valid => {
                if (valid) {
                    const formData = new FormData();
                    if (this.approve.onlineSignFlag === false || this.contract.length > 1) {
                        formData.append('file', this.approve.file.raw);
                    }
                    const jsonStr = JSON.stringify(
                        Object.keys(this.approve).reduce((acc, key) => {
                            if (!['file'].includes(key)) {
                                acc[key] = this.approve[key];
                            }
                            return acc;
                        }, {})
                    );
                    const blob = new Blob([jsonStr], {
                        type: 'application/json'
                    });
                   
                    formData.append("info", blob);
               
                    contractSignApply(formData).then(res => {
                        this.loading = false
                        if (res.code === 200) {
                            this.$messageUi.success('合同签署发起成功')
                            this.$store.commit('right/setChangeRed', true)
                            this.$emit('submit', 'confirm')
                        }
                    }).catch(err => { this.loading = false })
                } else {
                    this.loading = false
                    this.$messageUi.error('信息填写不完整，请检查')
                }
            })
        },
        close() {
            this.showFile = false
        },
    }
};
</script>

<style scoped>
.upload-demo {

    /*margin-top: 20px;*/
    width: 100% !important;
}
:deep(.el-upload)  {
    display: flex;
    gap: 20px;
    width: 100% !important;
}
</style>
